import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarPlus } from "@fortawesome/free-regular-svg-icons";

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title }) => {
  if (!isOpen) return null; // Visa inte modalen om den inte är öppen

  return (
    <div className="fixed inset-0 bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 flex flex-col gap-6 rounded-md shadow-lg text-center relative text-black">

        <div className="flex w-full justify-end">
          <button onClick={onClose} className="">
            <FontAwesomeIcon icon={faCalendarPlus} className="text-xl" />
          </button>
        </div>

        <div className="flex justify-center">
          <div className="bg-red-100 p-4 rounded-full flex justify-center items-center">
            <FontAwesomeIcon icon={faCalendarPlus} className="text-red-500" size="2x" />
          </div>
        </div>

        <p className="text-base font-normal">{title}</p>
        <div className="flex justify-around gap-2 w-fit self-center">
          <button
            onClick={onClose}
            className="btn btn-outline-primary"
          >
            No, cancel
          </button>
          <button
            onClick={onConfirm}
            className="btn btn-primary"
          >
            Yes, I'm sure
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal
